import React from 'react';
import { Layers, ChevronDown, ChevronUp, X } from 'lucide-react';

interface LegendItem {
  label: string;
  color: string;
  description?: string;
}

interface MapLegendProps {
  isVisible: boolean;
  onToggle: () => void;
  legendItems: LegendItem[];
  title?: string;
}

const MapLegend: React.FC<MapLegendProps> = ({
  isVisible,
  onToggle,
  legendItems,
  title = "Map Legend"
}) => {
  return (
    <div className={`bg-white/90 backdrop-blur-md shadow-lg rounded-2xl border border-white/20 overflow-hidden transition-all duration-300 ${isVisible ? 'w-80' : 'w-auto'}`}>
      {/* Header with Toggle */}
      <div 
        className="flex items-center justify-between cursor-pointer hover:bg-gray-50/50 transition-colors p-4"
        onClick={onToggle}
      >
        <div className="flex items-center gap-3">
          <div className="p-2 bg-[#179246]/10 rounded-lg text-[#179246]">
            <Layers className="h-5 w-5" />
          </div>
          <span className="font-semibold text-gray-700">{title}</span>
        </div>
        <button 
          className="p-1 hover:bg-gray-200 rounded-lg transition-colors"
          onClick={(e) => {
            e.stopPropagation();
            onToggle();
          }}
        >
          {isVisible ? (
            <ChevronDown className="h-5 w-5 text-gray-500" />
          ) : (
            <ChevronUp className="h-5 w-5 text-gray-500" />
          )}
        </button>
      </div>

      {/* Legend Content */}
      {isVisible && (
        <div className="px-4 pb-4 space-y-2 border-t border-gray-100 pt-3 max-h-[60vh] overflow-y-auto custom-scrollbar">
          {legendItems.map((item, index) => (
            <div key={index} className="flex items-start gap-3 p-2 hover:bg-gray-50 rounded-lg transition-colors">
              <div 
                className="w-5 h-5 rounded-md border border-gray-300 flex-shrink-0 mt-0.5 shadow-sm"
                style={{ backgroundColor: item.color }}
              />
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-gray-900">
                  {item.label}
                </div>
                {item.description && (
                  <div className="text-xs text-gray-500 mt-0.5">
                    {item.description}
                  </div>
                )}
              </div>
            </div>
          ))}
          
          {legendItems.length === 0 && (
            <div className="text-sm text-gray-500 text-center py-4">
              No legend items available
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MapLegend;